import React from "react";
import "../css/others/Table.css";
import { TableProps } from "../Interfaces/Interface";
const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString || dateString.trim() === "") return "N/A";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
const ReusableTable: React.FC<TableProps> = ({ columns, data, clickableColumn, onRowClick }) => {
  const getCellValue = (value: any, accessor: string) => {
    if (accessor.includes("Date")) {
      return formatDate(value);
    }
    return value !== undefined && value !== null && String(value).trim() !== "" ? value : "N/A";
  };
  return (
    <div className="table-container">
      <div className="table-inner-container">
        <table className="main-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {col.accessor === clickableColumn ? (
                        <span className="clickable" onClick={(e) => { e.stopPropagation(); onRowClick && onRowClick(row) }}>
                          {getCellValue(row[col.accessor], col.accessor)}
                        </span>
                      ) : (
                        getCellValue(row[col.accessor], col.accessor)
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="no-data">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default ReusableTable;